import React from 'react';
import { ConversationItem } from './ConversationItem';
import type { Conversation } from '../../../types/messages';

interface ConversationListProps {
  conversations: Conversation[];
  onConversationClick?: (conversationId: string) => void;
  currentUserName?: string | null;
}

export function ConversationList({ conversations, onConversationClick, currentUserName }: ConversationListProps) {
  return (
    <div className="divide-y divide-border">
      {conversations.map((conversation) => (
        <ConversationItem
          key={conversation.conversation_id}
          conversation={conversation}
          onConversationClick={onConversationClick}
          currentUserName={currentUserName}
        />
      ))}
    </div>
  );
}

